<template>
  <div class="info">
    <div v-if="messageList && messageList.length > 0">
      <div
        v-for="message in messageList"
        :key="message.id"
        class="mb15 messageBox">
        <div v-if="message.type === 'card'">
          <div class="message">
            <div v-if="message.img && message.img.length > 0" class="image"><img :src="message.img" alt=""></div>
            <div v-if="message.text && message.text[lang].length > 0" class="text">{{message.text[lang]}}</div>
          </div>
          <SetLink v-if="message.link && message.linkActive"
            :linkTarget="message.link"
            :lang="lang"
            class="messageLink" />
        </div>
        <div v-if="message.type === 'tagGroup' && message.tag && message.tag.length > 0">
          <div class="tags">
            <button
              v-for="tag in message.tag"
              :key="tag.id"
              type="button"
              class="tag"
              @click="getMessage('tag', tag.id)">{{tag.tag[lang]}}</button>
          </div>
        </div>
        <div v-if="message.type === 'userInfo'">
          <div class="message">
            <UserInfo
              :locale="locale"
              :lang="lang"
              :user="user"
              @updateUserinfo="updateUserinfo" />
          </div>
        </div>
      </div>
    </div>
    <button
      v-if="enterance"
      type="button"
      class="btnTalk wh"
      @click="create">
      <img src="@/assets/img/ico_send.png" class="imgSend">
      {{locale.talk_chat}}
    </button>
    <div class="mb30"></div>
  </div>
</template>

<script>
import UserInfo from '@/components/Talk/UserInfo'
import SetLink from '@/components/Util/SetLink.vue'

export default {
  props: [
    'locale',
    'lang',
    'user',
    'enterance',
    'messageList'
  ],
  components: {
    UserInfo,
    SetLink
  },
  computed: {
    // messageList () {
    //   return this.enterance || this.missed || []
    // }
  },
  methods: {
    create () { // create new token
      this.$emit('create')
    },
    getMessage (type, id) {
      const data = {
        type: type,
        id: id
      }
      const isTalking = !this.enterance
      this.$emit('getMessage', data, isTalking)
    },
    updateUserinfo () {
      this.$emit('updateUserinfo')
    }
  }
}
</script>
